import { createI18n } from 'vue-i18n';
import en from './en';

const i18n = createI18n({ locale: 'en', messages: { en }, warnHtmlInMessage: 'off' });

export default i18n;
